import { Text } from '@mantine/core';

type MetadataRowProps = {
  label: string;
  value: string | number | boolean | null | undefined;
};

export function MetadataRow({ label, value }: MetadataRowProps) {
  const displayValue = value === null || value === undefined || value === '' ? '-' : String(value);
  return (
    <Text size="sm" style={{ fontFamily: 'monospace' }}>
      <Text span fw={600}>
        {label}:
      </Text>{' '}
      {displayValue}
    </Text>
  );
}
